module.exports = __webpack_public_path__ + "static/media/ios-trending-down.6535adf9.svg";